import { useAuth } from 'context';
import { AuthOverlay } from 'components/auth-overlay';
import { SpinnerFullPage } from '@updater/ui-uds';
import { useIsAuthenticated } from '@updater/auth';
import { PropsWithChildren } from 'react';
import { AuthOverlayOtp } from 'components/auth-overlay-otp';
import { useFeature } from '@growthbook/growthbook-react';

export const LoginRequired: React.FC<PropsWithChildren> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  // TODO: nix every use of currentUserUUID before removing
  const { currentUserUUID } = useAuth();
  /* Experiment to remove the `Password` screen */
  const { value: skipPasswordVariant } = useFeature('consumer_skip_password');

  if (!isAuthenticated) {
    return skipPasswordVariant ? (
      <AuthOverlayOtp title="Welcome back!" />
    ) : (
      <AuthOverlay title="Welcome back!" />
    );
  }

  if (currentUserUUID == null) {
    return <SpinnerFullPage />;
  }

  return <>{children}</>;
};
